import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as HandBasinIcon } from "../../Assets/hand_basin.svg";

const HandBasinRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
  orientation, // <-- Добавлен для новой логики
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.HAND_BASIN];
  const elementVisualWidthM = element.width || defaults.width;
  const elementPlanDepthM = element.depth || defaults.depth;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementPlanDepthPx = elementPlanDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  const yOffset =
    placementSideFactor * (wallThicknessPx / 2 + elementPlanDepthPx / 2);

  const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "#fff",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",
    strokeWidth: isSelected ? 1.5 : 1,
    pointerEvents: "none", // <-- Делаем иконку "прозрачной" для кликов
  };

  // --- Правильная логика поворота ---
  let rotationAngle;
  if (orientation === 'v') {
    // Для вертикальных стен: правильная ориентация
    rotationAngle = placementSideFactor === 1 ? 90 : -90;
  } else { // orientation === 'h'
    // Для горизонтальных стен: поворачиваем чтобы спина была к стене
    rotationAngle = placementSideFactor === 1 ? 90 : -90;

  }

  const groupTransform = `translate(0, ${yOffset}) rotate(${rotationAngle})`;

  return (
    <g transform={groupTransform}>
      {/* Невидимый прямоугольник для перехвата кликов */}
      <rect
        x={-elementVisualWidthPx / 2}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx}
        height={elementPlanDepthPx}
        fill="transparent"
      />
      {/* Видимая иконка */}
      <HandBasinIcon
         x={-elementVisualWidthPx / 2.4}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx}
        height={elementPlanDepthPx}
        style={iconStyle}
        preserveAspectRatio="none"
      />
    </g>
  );
};
export default React.memo(HandBasinRenderer);